import styled from 'styled-components'
import {
  PRIMARY_BLUE_02,
  PRIMARY_BLUE_03,
  GRAY_SCALE_04,
  SECONDARY_GREEN_07,
  SECONDARY_GREEN_10,
} from 'bd-web-components/src/utils/dash-colors'
import { getDashColor } from '../../styles'

export const ContainerCard = styled.div`
  cursor: pointer;
  width: 100%;
  max-width: 100%;
  height: 100%;
  @media (max-width: 1152px) {
    max-width: 100%;
  }
`

export const DetailCard = styled.div`
  display: flex;
  height: 100%;
  border: 1px solid ${getDashColor('GRAY_SCALE_09', 'BEIGE')};
  border-radius: 5px;
  padding: 0px 30px;
  margin: 8px;
  word-break: break-word;

  @media (max-width: 762px) {
    width: 100%;
    padding: 12px 20px;
  }
`

export const LabelCard = styled.div`
  color: ${GRAY_SCALE_04};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding: 0 20px;
  align-content: center;
  width: 100%;
`

export const CardTitle = styled.div`
  color: ${PRIMARY_BLUE_02};
  font-size: 17px;
  font-style: normal;
  font-weight: 700;
  line-height: 19.6px;
`

export const IconDetailContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  &:before {
    content: '';
    width: 38px;
    height: 38px;
    background-color: ${SECONDARY_GREEN_10};
    border-radius: 100px;
    position: absolute;
    z-index: 0;
  }
  & div {
    z-index: 1;
  }
`

export const TermsContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 560px;
`

export const TermsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
`

export const TermsDescription = styled.p`
  margin: 0;
  line-height: 1.5;
  color: ${PRIMARY_BLUE_03};
`

export const TermsLink = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  width: fit-content;
  margin-top: 12px;
  padding: 0;
  background: transparent;
  border: none;
  font: inherit;
  font-weight: 600;
  color: ${SECONDARY_GREEN_07};
  text-decoration: underline;
  cursor: pointer;

  &:disabled {
    cursor: default;
    opacity: 0.6;
  }
`

export const CheckboxRow = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 20px 0;
  cursor: pointer;
`

export const ButtonRow = styled.div`
  display: flex;
  gap: 12px;
`
